import { useEffect, useState } from 'react'
import { doc, getDoc } from 'firebase/firestore'
import { db } from '../lib/firestore'

export function useRidersHelped(): number | null {
  const [count, setCount] = useState<number | null>(null)

  useEffect(() => {
    let cancelled = false

    async function fetchCount() {
      try {
        const snap = await getDoc(doc(db, 'stats', 'community'))
        if (cancelled) return
        if (snap.exists()) {
          const value = snap.data().ridersHelped
          setCount(typeof value === 'number' ? value : null)
        }
      } catch {
        // stats/community may not be readable without auth — fail silently
        // The counter simply won't render on public pages
      }
    }

    fetchCount()
    return () => { cancelled = true }
  }, [])

  return count
}

export function formatNumber(n: number): string {
  return n.toLocaleString('en-US')
}
